module.exports = __webpack_public_path__ + "static/media/05-map.a6df546e.png";